// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreFreeShipping = (client) => ({
    /**
     * `GET /store/free-shipping/prices`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreFreeShippingPricesRetrieve
     * @source apps/backend/src/api/store/free-shipping/prices/route.ts
     */
    listPrices: (query, headers) => client.fetch("/store/free-shipping/prices", { method: "GET", query, headers }),
});
//# sourceMappingURL=free-shipping.js.map